import BannerSvc from '@/common/service/modules/BannerSvc';

export default {
  async fetchBannerList({ commit }) {
    const { entity } = await BannerSvc.getBannerList();
    commit('setBannerList', entity.list);
  },

  async fetchPopupList({ commit }) {
    const { entity } = await BannerSvc.getPopupList();
    commit('setPopupList', entity.list);
  },

  fetchTomorrowDate({ commit }, tomorrowDate) {
    localStorage.setItem('expiredDate', JSON.stringify(tomorrowDate));
  }
};
